import {useState, useEffect} from 'react';
import {getFeatureFlags} from '@chekin/core';
import {LAYOUT_MODE_KEY} from 'utils/constants';

const resolveKioskoActivation = (): boolean => {
  const isFeatureEnabled = getFeatureFlags('IT_4334_KIOSKO_MVP');
  const hasQueryParam =
    new URL(window.location.href).searchParams.get('layout') === 'kiosko';
  const hasStoredLayout = localStorage.getItem(LAYOUT_MODE_KEY) === 'kiosko';

  if (hasQueryParam && isFeatureEnabled) {
    return true;
  }

  if (hasStoredLayout && isFeatureEnabled) {
    return true;
  }

  if (hasStoredLayout && !isFeatureEnabled) {
    localStorage.removeItem(LAYOUT_MODE_KEY);
  }

  return false;
};

export const useToggleKioskoMode = () => {
  const [isKioskoActivated] = useState(resolveKioskoActivation);

  useEffect(function cleanLayoutQueryParam() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('layout')) {
      url.searchParams.delete('layout');
      window.history.replaceState({}, '', url.toString());
    }
  }, []);

  return {isKioskoActivated};
};
